import React, { FC } from 'react'
import { IconBaseProps } from 'react-icon-base'
import { StyledIcon } from './styled-icon'

export const CsWarningIcon: FC<IconBaseProps> = (props) => (
  <StyledIcon viewBox="0 0 1024 1024" {...props}>
    <g>
      <path d="M438.857 82.286q119.429 0 220.286 58.857t159.714 159.714 58.857 220.286-58.857 220.286-159.714 159.714T438.857 960t-220.286-58.857T58.857 741.429 0 521.143t58.857-220.286 159.714-159.714 220.286-58.857zM512 794.857V686.286q0-8-5.143-13.429t-12.571-5.429H384.572q-7.429 0-13.143 5.714t-5.714 13.143v108.571q0 7.429 5.714 13.143t13.143 5.714h109.714q7.429 0 12.571-5.429T512 794.855zm-1.143-196.571l10.286-354.857q0-6.857-5.714-10.286-5.714-4.571-13.714-4.571H376.001q-8 0-13.714 4.571-5.714 3.429-5.714 10.286l9.714 354.857q0 5.714 5.714 10t13.714 4.286h105.714q8 0 13.429-4.286t6-10z" />
    </g>
  </StyledIcon>
)

CsWarningIcon.displayName = 'CsWarningIcon'
